import {
    BaseContent,
    ContentModelName,
    FooterPayload, InfoPage,
    InfoPagePayload,
    LandingPagePayload,
    OnboardingPagePayload,
    PanelSection,
    PokerPagePayload,
    PopupAppInstall,
    PopupManager,
    PromoPage,
    STRAPI_COLLECTIONS, UserLevels
} from "./types";
import {Dispatch} from "redux";
import ContentfulClientService from "../contenful/ContentfulClientService";
import {getContainer} from "../ioc/IOCSetup";
import {Asset, Entry, EntryCollection} from "contentful";
import {AppState} from "../RootReducer";
import {ContentStatus} from "./ContentfulReducer";
import {AppMode} from "../http/protocol";


export enum ContentfulActionTypes {
    FETCH_ENTRIES_REQUEST = "@contentful/entries/request",
    FETCH_ENTRIES_SUCCESS = "@contentful/entries/response",
    FETCH_ENTRIES_ERROR = "@contentful/entries/error",
    FETCH_MULTIPLE_ENTRIES_REQUEST = "@contentful/multipleentries/request",
    FETCH_MULTIPLE_ENTRIES_SUCCESS = "@contentful/multipleentries/response",
    FETCH_MULTIPLE_ENTRIES_ERROR = "@contentful/multipleentries/error",
    CHANGE_LNG = "@contentful/changelng/set",
}

export type ContenfulActions =
    | { type : ContentfulActionTypes.FETCH_ENTRIES_REQUEST, contentModelName : ContentModelName}
    | { type : ContentfulActionTypes.FETCH_ENTRIES_SUCCESS, contentModelName: ContentModelName, payload: LandingPagePayload | OnboardingPagePayload  |
        PokerPagePayload | PopupAppInstall | PopupManager | InfoPagePayload | PromoPage | PanelSection | FooterPayload}
    | { type : ContentfulActionTypes.FETCH_ENTRIES_ERROR, error: string, contentModelName : ContentModelName }
    | { type : ContentfulActionTypes.FETCH_MULTIPLE_ENTRIES_REQUEST, contentModelName: ContentModelName }
    | { type : ContentfulActionTypes.FETCH_MULTIPLE_ENTRIES_SUCCESS, contentModelName: ContentModelName, payload: any}
    | { type : ContentfulActionTypes.FETCH_MULTIPLE_ENTRIES_ERROR, error: string, contentModelName: ContentModelName }
    | { type : ContentfulActionTypes.CHANGE_LNG }


/**
 * @deprecated use fetchAndParseContent
 */
export const fetchContent = (contentModelName: ContentModelName, locale?: string, listType? : boolean) => {
    return fetchAndParseContent(contentModelName, locale, listType)
}

/**
 * Fetch multiple content models at the same time, only fetch content models with one entry (such as landingpage, onboarding page etc)
 * @param models
 * @param locale
 */
export const fetchMultiple = ( models : ContentModelName[], locale? : string) => {
    return async  (dispatch : Dispatch, getState : () => AppState) => {
        const toLoad = models.filter(m => getState().contentful?.contentModelStatus?.[m] != ContentStatus.SUCCESS);
        toLoad.forEach(m =>  dispatch({type: ContentfulActionTypes.FETCH_ENTRIES_REQUEST, contentModelName : m}));
        let service = getContainer().getContentfulClientService();
        let entries = await service.getEntriesForMultipleTypes(models, locale);
        const result : BaseContent[] = mapContentList(entries);
        result.forEach(r => {
            dispatch({type: ContentfulActionTypes.FETCH_ENTRIES_SUCCESS, contentModelName: r._contentType, payload: r});
        });
    }
}

export const getStrapiModel = (model : ContentModelName) => {
    if(!getContainer().getStrapiClient().isEnabled()) {
        return undefined;
    }
    return STRAPI_COLLECTIONS.find(m => m.model === model)
}

export const fetchAndParseContentByNameId = async <T>(contentModelName : ContentModelName, nameId : string, lng? : string) : Promise<T[]>  => {
    let strapi = getStrapiModel(contentModelName);
    if(!strapi) {
        return Promise.reject();
    }
    let l = getContainer().getSettingsService().getActiveLocale().code;
    let resp = await getContainer().getStrapiClient().fetchContentByNameId(strapi.path + (strapi.single ? "" : "s"), nameId, lng ?? l);
    let content = mapStrapiContent<T>(resp as any);
    return content as T[];
}

export const fetchAndParseContentByModel = async <T>(contentModelName : ContentModelName, lng : string) : Promise<T[]>  => {

    const service = getContainer().getContentfulClientService();
    const strapiClient = getContainer().getStrapiClient();
    let strapi = getStrapiModel(contentModelName);
    if(strapi && strapiClient.isEnabled()) {
        let resp = await getContainer().getStrapiClient().fetchContent(strapi.path + (strapi.single ? "" : "s"), lng);
        return mapStrapiContent(resp as any)
    } else {
        const e : EntryCollection<any> = await service.getUserLevelsPage(lng);
        return mapContentList(e)
    }
}
export const fetchAndParseContentByMode = (contentModelName: ContentModelName, appmode: AppMode, locale?: string) => {
    return async (dispatch: Dispatch, getState : () => AppState) => {
        try {
            let status = getState()?.contentful?.contentModelStatus?.[contentModelName];
            if(status == ContentStatus.SUCCESS || status == ContentStatus.IN_PROGRESS) {
                return;
            }

            let strapi = getStrapiModel(contentModelName);
            if(strapi) {
                let l = getContainer().getSettingsService().getActiveLocale().code;
                let resp = await getContainer().getStrapiClient().fetchContent(strapi.path + (strapi.single ? "" : "s"), l);
                let content : LandingPagePayload[] = mapStrapiContent(resp as any);
                const siteNameId = getContainer().getSettingsService().getSettingsData()?.siteNameId ?? "default";
                if(content?.length > 0) {

                    if(!siteNameId || siteNameId === "default") {
                        content =  content.filter(c => !c.siteNameId || c.siteNameId === "default");
                    }  else {
                        let all = content;
                        content =  content.filter(c => c.siteNameId === siteNameId);
                        if(content.length == 0) { // fallback to content without any siteNameId
                            content = all.filter(c => !c.siteNameId);
                        }
                    }

                    let contentWithMode : LandingPagePayload[] = [];
                    if(appmode && appmode.trim().length > 0) {
                        contentWithMode = content.filter(c => c.appmode == appmode);
                    }
                    if(contentWithMode.length > 0) {
                        content = contentWithMode;
                    }
                }


                dispatch({type: ContentfulActionTypes.FETCH_ENTRIES_SUCCESS, contentModelName: contentModelName, payload: content[0]});
            } else {
                dispatch({type: ContentfulActionTypes.FETCH_ENTRIES_REQUEST, contentModelName : contentModelName})
                let contentfulClientService: ContentfulClientService = getContainer().getContentfulClientService();
                let data;
                try{
                    data = await contentfulClientService.getEntries(contentModelName, locale);
                } catch (e) {
                    data = await contentfulClientService.getEntries(contentModelName, undefined);
                }
                if(data && data.items && data.items.length > 0) {
                    let content = mapContentList(data)
                    let contentWithMode: any[] = [];
                    const siteNameId = getContainer().getSettingsService().getSettingsData()?.siteNameId ?? "default";
                    if(siteNameId === "default") {
                        content =  content.filter(c => !c.siteNameId || c.siteNameId === "default");
                    }  else {
                        content =  content.filter(c => c.siteNameId === siteNameId);
                    }
                    content.forEach((c: LandingPagePayload)=>{
                        if(c.appmode == appmode){
                            contentWithMode.push(c)
                        }
                        if(!c.appmode){
                            contentWithMode = content
                        }
                    })
                    if(contentWithMode.length == 0){
                        contentWithMode = content
                    }
                    dispatch({type: ContentfulActionTypes.FETCH_ENTRIES_SUCCESS, contentModelName: contentModelName, payload: contentWithMode[0]});
                } else {
                    dispatch({type: ContentfulActionTypes.FETCH_ENTRIES_ERROR, contentModelName : contentModelName, error: "no content"});
                }
            }



        } catch (e) {
            console.log("error ", e)
            dispatch({type: ContentfulActionTypes.FETCH_ENTRIES_ERROR, contentModelName : contentModelName, error: e});
        }
    }
}

export const hasStrapiSupport = (m : ContentModelName) => {
    if(STRAPI_COLLECTIONS.find(c => c.model === m)) {
        return true;
    }
    return false;
}

interface StrapiResponse {
    data : StrapiContent[]|StrapiContent;
}
interface StrapiContent {
    attributes : {[key:string] : any}
}
export function mapStrapiContent<T>(resp: StrapiResponse) : T[] {
    //console.log("strapi response = ", resp);
    if(resp.data && Array.isArray(resp.data)) {
        let mapped = resp.data.map(c => {
            let obj = c.attributes;
            obj = mapStrapiAttributes(obj);
            return obj;
        });
        //console.log("strapi response mapped = ", mapped);
        return mapped as T[];
    } else {
        return [mapStrapiAttributes(resp.data?.attributes)] as T[];
    }


}

function mapStrapiImage(m: any) {
    //icon1.fields.file.details.image.width
    return {
        fields: {
            file: {
                url: m.url,
                contentType: m.mime,
                details : {
                    image : {
                        width : m.width,
                        height : m.height
                    }
                }
            },
            title: m.alternativeText,
            description: m.caption
        }
    };
}

export function mapStrapiAttributes(m : any)  {

    if(!m) {
        return m;
    }

    if(m.ext && m.url) {
        let img = mapStrapiImage(m);
        return img;
    }
    let obj : any = {};
    let keys = Object.keys(m)
    keys.forEach(k => {
        if((m[k]?.data && !Array.isArray(m[k]?.data)) || m[k]?.data === null) {
            obj[k] = mapStrapiAttributes(m[k]?.data?.attributes);
        } else if(typeof(m[k]) == "object" && (Array.isArray(m[k]) || Array.isArray(m[k]?.data))){
            if(Array.isArray(m[k]?.data)) {
                obj[k] = m[k].data.map((v : any) => mapStrapiAttributes(v.attributes ?? v))
            } else {
                obj[k] = m[k].map((v : any) => mapStrapiAttributes(v));
            }
        } else if(typeof(m[k]) == "object"){
            obj[k] = mapStrapiAttributes(m[k]);
        } else {
            if(k === "id") {
                //make it backwards compatible with contentful
                obj["_id"] = "strapi_"+m[k];
            }
            obj[k] = m[k];
        }
    })


    return obj;
}

export const fetchAndParseContent = (contentModelName: ContentModelName, locale?: string, listType? : boolean, ids?: string[], appmode?: AppendMode | undefined, limit ?: number) => {

    if (ids) {
        listType = true
    }

    return async (dispatch: Dispatch, getState : () => AppState) => {
        try {

            let status = getState()?.contentful?.contentModelStatus?.[contentModelName];
            if(status == ContentStatus.SUCCESS || status == ContentStatus.IN_PROGRESS) {
                return;
            }

            let strapi = getStrapiModel(contentModelName);
            if(strapi) {
                let l = getContainer().getSettingsService().getActiveLocale().code;
                let resp;
                if(contentModelName === ContentModelName.NEWSARTICLE) {
                 resp = await getContainer().getStrapiClient().fetchArticlesContent(strapi.path + (strapi.single ? "" : "s"), l);
                } else {
                 resp = await getContainer().getStrapiClient().fetchContent(strapi.path + (strapi.single ? "" : "s"), l);
                }
               
                let content = mapStrapiContent(resp as any)
                dispatch({type: ContentfulActionTypes.FETCH_ENTRIES_SUCCESS, contentModelName: contentModelName, payload: listType ? content : content[0]});
            } else {
                dispatch({type: ContentfulActionTypes.FETCH_ENTRIES_REQUEST, contentModelName : contentModelName})
                let contentfulClientService: ContentfulClientService = getContainer().getContentfulClientService();
                let data;
                try{
                    data = await contentfulClientService.getEntries(contentModelName, locale, ids, (limit || 100));
                } catch (e) {
                    data = await contentfulClientService.getEntries(contentModelName, undefined, ids, (limit || 100));
                }
                if(data && data.items && data.items.length > 0) {
                    let content = mapContentList(data);
                    dispatch({type: ContentfulActionTypes.FETCH_ENTRIES_SUCCESS, contentModelName: contentModelName, payload: listType ? content : content[0]});
                } else {
                    dispatch({type: ContentfulActionTypes.FETCH_ENTRIES_ERROR, contentModelName : contentModelName, error: "no content"});
                }
            }

        } catch(e) {
            console.log("error ", e)
            dispatch({type: ContentfulActionTypes.FETCH_ENTRIES_ERROR, contentModelName : contentModelName, error: e});
        }
    }
}



export const  mapContentList = <T> (entries : EntryCollection<any>) : any[] =>  {
    let content : any[] = entries.items.map((e) => {

         return mapContent(e, entries.includes);
    }).filter(e => !!e);
    return content;
}
export const mapContent = (entry : Entry<any>, includes : any) => {

    if(!entry) {
        return undefined;
    }
    if(!entry.fields) {
        return mapOne(entry, includes);
    }
    let keys = Object.keys(entry.fields);
    let mapped : any = {};
    keys.forEach(k => {
        let value = entry.fields[k];
        mapped[k] = mapOne(value,includes);
    })
    if(entry.sys?.contentType?.sys?.id)  {
        mapped["_contentType"] = entry.sys.contentType.sys.id;
    }
    if(entry.sys.id) {
        mapped["_id"] = entry.sys.id;
    }
    return mapped;
}
export const mapArray = (arr : any[], includes : any) : any[] => {
    if(arr && arr.length > 0) {
        return arr.map(a => {
            return mapContent(a, includes);
        });
    } else {
        return [];
    }
}
export const mapOne = (value : any, includes : any) : any => {
    if(Array.isArray(value)) {
        return  mapArray(value, includes);
    } else if(value.sys && value.sys.type === "Link" && value.sys.linkType == "Entry" && value.sys.id) {
        let linkedEntry = includes.Entry.find( (e : Entry<any>) => e.sys.id === value.sys.id);
        if(linkedEntry) {
            return mapContent(linkedEntry,includes);
        } else {
            return  undefined;
        }
    } else if(value.sys && value.sys.type == "Link" && value.sys.linkType == "Asset" && value.sys.id) {
        let linkedAsset : Asset = includes.Asset.find( (e : Asset) => e.sys.id === value.sys.id);
        if(linkedAsset && linkedAsset.fields) {
            return linkedAsset;
        } else {
            return  undefined;
        }
    } else if(value.sys && value.sys.type == "Asset" && value.fields?.file) {
        return value;
    } else if(value.nodeType == "document" && value.content) {
        return value;
    } else if(!value.sys){
        return  value;
    } else if(value.sys.type == "Entry") {
        return mapContent(value, includes);
    } else {
        return undefined;
    }
}




export const fetchMultipleContent = (contentModelName: ContentModelName, locale?: string) => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({type: ContentfulActionTypes.FETCH_MULTIPLE_ENTRIES_REQUEST})
            let contentfulClientService: ContentfulClientService = getContainer().getContentfulClientService();
            let data;
            try{
                data = await contentfulClientService.getEntries(contentModelName, locale);
            } catch (e) {
                data = await contentfulClientService.getEntries(contentModelName);
            }
            let pages: any = {};
            pages["pages"] = data.items.map((item: any) => (item.fields));
            dispatch({type: ContentfulActionTypes.FETCH_MULTIPLE_ENTRIES_SUCCESS, contentModelName: contentModelName, payload: pages });
        } catch(e) {
            dispatch({type: ContentfulActionTypes.FETCH_MULTIPLE_ENTRIES_ERROR, error: e});
        }
    }
}
export const fetchPromoPage = async (page : string, lng : string) => {
    const service = getContainer().getContentfulClientService();
    const strapiClient = getContainer().getStrapiClient();
    if(strapiClient.isEnabled()) {
        return await fetchAndParseContentByNameId<PromoPage>(ContentModelName.PROMOPAGE, page, lng);
    } else {
        const e : EntryCollection<any> = await service.getPromoPage(page, lng);
        return mapContentList(e)
    }
}

export const fetchInfoPage = async (page : string, lng : string) => {
    const service = getContainer().getContentfulClientService();
    const strapiClient = getContainer().getStrapiClient();
    if(strapiClient.isEnabled()) {
        return await fetchAndParseContentByNameId<InfoPage>(ContentModelName.INFOPAGE, page, lng);
    } else {
        const e : EntryCollection<any> = await service.getInfoPage(page, lng);
        return mapContentList(e)
    }
}

export const fetchUserLevelsPage = async (lng : string) : Promise<any[]> => {
    return fetchAndParseContentByModel(ContentModelName.USERLEVELS, lng);
}

export const changeLng = () => (
    {type: ContentfulActionTypes.CHANGE_LNG}
)
